<template>
  <div class="upload-cv">
    <div v-if="showTitle" class="paragraph-s paragraph-dark-gray text">{{ titleLabelText }}</div>
    <slot
      :acceptedFileTypes="acceptedFileTypes"
      :changeAttachmentsField="changeAttachmentsField"
      name="attachment-field"
    >
      <attachments-field
        :change-attachments-field="changeAttachmentsField"
        :file-attachments="files"
        :accepted-file-types="acceptedFileTypes"
        :error="error"
        :loading="loading"
        :btn-attachment-text="labels.uploadCv"
        :empty-label="emptyLabelText"
        :empty-label-classes="'paragraph-xs'"
      ></attachments-field>
    </slot>
  </div>
</template>

<script>

import AttachmentsField from '../form/AttachmentsField';

export default {
  props: {
    showTitle: {type: Boolean, default: true},
    titleText: {type: String, required: false},
    showEmptyLabel: {type: Boolean, default: true},
    files: Array,
    error: String,
    loading: {type: Boolean, default: false}
  },
  data() {
    const maxSize = 10;
    const string = this.$gettext('no file attached (max %{maxSize}MB)');

    return {
      emptyLabel: this.$gettextInterpolate(string, {maxSize}),
      maxFileSize: maxSize,
      megaByte: 1024 * 1024,
      acceptedFileTypes:
        '.txt,.doc, .docx, .rtf, .md, .html, .pdf, .odt, .ppt, .xls, .xlsx, .ott, .key, .pages, .numbers'
    };
  },
  computed: {
    labels() {
      return {
        uploadCv: this.$gettext('Upload CV'),
        uploadCvOptional: this.$gettext('Upload CV (optional)')
      };
    },
    emptyLabelText() {
      return this.showEmptyLabel ? this.emptyLabel : '';
    },
    titleLabelText() {
      return this.titleText || this.labels.uploadCvOptional;
    }
  },
  methods: {
    changeAttachmentsField(files) {
      if (files && files.length) {
        this.handleFileAttach(files);
      } else {
        this.$emit('on-file-remove', files);
      }
    },
    handleFileAttach(files) {
      if (this.validateAttachments(files)) {
        this.$emit('on-file-attach', files);
      }
    },
    validateAttachments(files) {
      if (!this.maxFileSize) {
        return true;
      }

      for (let i in files) {
        if (files[i].size > this.maxFileSize * this.megaByte) {
          const string = this.$gettext('This file is too large (max %{maxSize}MB)');
          this.parseError(this.$gettextInterpolate(string, {maxSize: this.maxFileSize}));

          return false;
        }
      }

      return true;
    },
    parseError(error) {
      this.$toast.open({message: error, type: 'is-danger'});
    }
  },
  components: {
    AttachmentsField
  }
};
</script>

<style lang="scss" scoped>
.upload-cv {
  margin: 20px 0;

  .text {
    margin-bottom: 15px;
  }
}
</style>
